
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/listing/[slug]",
      function () {
        return require("private-next-pages/listing/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/listing/[slug]"])
      });
    }
  